// Initialize the bundle
import './init';

// WallpaperLayout component
export { default } from './components/wallpaper';
